"use client"

import {store} from "@/core/redux/store";
import {Provider} from "react-redux";
import MenuTabComponent from "@/core/menu/menuTab.component";

export default function MenuTabContainerComponent() {

    return (
        <Provider store={store}>
            <MenuTabComponent/>
        </Provider>
    )

}